import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";
import { useEffect, useRef, useState  } from "react";

export default function GuardianWaiting({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const pollingEnabled = useRef(true);

    const guardianResponseReceived =  flowData?.guardianResponseReceived === true;
    const guardianDecision = flowData?.guardianDecision;

    const loadingRef = useRef(false);
    useEffect(() => {
        loadingRef.current = loading;
    }, [loading]);

    const checkGuardianStatus = async () => {
        if (!pollingEnabled.current) {
            return;
        }

        await next({
            action: "check_guardian_status"
        });
    };

    useEffect(() => {
        if (flowData?.guardianResponseReceived) {
            pollingEnabled.current = false;
        }
    }, [flowData?.guardianResponseReceived]);

    /*useEffect(() => {
        const timer = setInterval(() => {

            if (!pollingEnabled.current) {
                return;
            }

            if (loadingRef.current) {
                return;
            } //Now it always sees the latest loading state.


            checkGuardianStatus();
        },30000); 
        return () => clearInterval(timer);
    },[]);*/

    useEffect(() => {

        // Restart polling when this screen is entered again.
        const isWaitingStep =
            flowContext?.currentStep === STEPS.GUARDIAN_WAITING;

        pollingEnabled.current =
            isWaitingStep &&
            flowData?.guardianResponseReceived !== true;

        if (!pollingEnabled.current) {
            return;
        }

        const timer = setInterval(() => {
            if (!pollingEnabled.current || loadingRef.current) {
                return;
            }

            checkGuardianStatus();
        }, 30000);

        return () => {
            clearInterval(timer);
            pollingEnabled.current = false;
        };
    }, [
        flowContext?.flowId,
        flowContext?.currentStep,
        flowData?.guardianResponseReceived
    ]);

    const goBack = () => {
        if (loading) return;
        setError("");

        pollingEnabled.current = false;

        next({
            action: "change_guardian_info"
        });
    };

    const resendConsent = () => {
        if (loading) return;
        setError("");
        //pollingEnabled.current = false;  Do not disable polling on resend
        next({
            action: "resend_guardian_consent_link"
        });
    };


    return (
       <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-header">

                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>

            </div>

            <div className="page-content guardian-page">

                <div className="selected-service-icon guardian-icon" />

                <h3 className="guardian-title">
                    {guardianResponseReceived
                        ? guardianDecision === "REJECTED"
                            ? "Guardian Approval Not Received"
                            : "Guardian Response Received"
                        : "Waiting for Guardian Approval"}
                </h3>

                <p className="guardian-text">
                    {guardianResponseReceived
                        ? guardianDecision === "REJECTED"
                            ? "Your parent or legal guardian did not approve this waiver. You cannot continue with this request."
                            : "The Guardian consent process has ended."
                        : "Your parent or legal guardian must approve this waiver before you can continue."}
                </p>

                {/* !guardianResponseReceived && (
                    <>
                    <p className="guardian-text">
                        We sent a secure consent link to:
                    </p>
                    <div className="guardian-phone-card">

                        <span className="guardian-phone-icon">
                            📞
                        </span>

                        <a href={`tel:${flowData?.guardian?.mobile}`}>
                            {flowData?.guardian?.mobile}
                        </a>

                    </div>
                    <p>
                        <a
                            href={flowData.tmpResponseVars.guardianConsentUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Temp Display: Click Here To Open Guardian Consent Link.
                        </a>
                        {flowData.tmpResponseVars.guardianConsentUrl}
                    </p> 
                </>
                ) */}


                {!guardianResponseReceived && (
                    <>
                        <p className="guardian-text">
                            This screen will update when your guardian's response is received.
                        </p>

                        <p className="guardian-text">
                            <strong>
                                Haven't shared the link yet, or need to share it again?
                            </strong>
                         </p>  
                         <p className="guardian-text">
                            Return to the previous screen to copy or share the guardian consent link.
                        </p>
                    </>
                )}

                
            </div>

            <div className="page-footer">
            {guardianResponseReceived && guardianDecision === "REJECTED" ? (
                <button
                    className="primary-button"
                    onClick={() => window.location.reload()}
                >
                    Start Again
                    <span className="button-arrow">›</span>
                </button>
            ) : !guardianResponseReceived ? (
                <>
                    {/*<button
                        className="primary-button"
                        onClick={resendConsent}
                    >
                        Resend consent link
                        <span className="button-arrow">›</span>
                    </button> */}

                    <button
                        className="primary-button"
                        onClick={goBack}
                    >
                        Back to Share Link
                        <span className="button-arrow">›</span>
                    </button>
                </>
            ) : null}
            <div className="powered-by">
                Powered by <strong>DidYouSign</strong>
            </div>

        </div>

        </div>
    );
}